import React, { useState, useEffect, useRef, useCallback } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { FiltroNivelCurso } from "../../components/FiltroNivelCurso";

import { getListaMatricula } from "../../service/Matricula";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { loading, setUsuarioLogin } from "../../actions";
import { PageLibroRegistro } from "./PageLibroRegistro";
import "./libro.css";
import { Libro } from "./Libro";

export const PageLibro = () => {
    const [globalFilter, setGlobalFilter] = useState("");
    const [dataTable, setDataTable] = useState(null);
    const [dataTableFilter, setDataTableFilter] = useState(null);
    const [showRegistroLibro, setShowRegistroLibro] = useState(false);
    const dispatch = useDispatch();
    const toast = useRef(null);
    const filtroRef = useRef(null);
    const dataSelectLibro = useRef(null);

    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    useEffect(() => {
        loadData();
    }, [anio]);

    const loadData = async () => {
        if (colegio.id !== undefined && anio.anio !== undefined) {
            dispatch(loading(true));
            filtroRef.current.click();
            var data = await getListaMatricula(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                setDataTable(data.matricula_pie);
                setDataTableFilter(data.matricula_pie);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }

            dispatch(loading(false));
        } else {
            setDataTable([]);
            setDataTableFilter([]);
        }
    };

    const getFiltroNivelCurso = useCallback(
        (data) => {
            if (data.es_nivel) {
                if (data.idnivel == 0) {
                    setDataTableFilter(dataTable);
                } else {
                    setDataTableFilter(dataTable.filter((o) => o.idnivel == data.idnivel));
                }
            } else {
                if (data.id == 0) {
                    setDataTableFilter(dataTable.filter((o) => o.idnivel == data.idnivel));
                } else {
                    setDataTableFilter(dataTable.filter((o) => o.idgrado== data.id &&
                     o.idnivel == data.idnivel));
                }
            }
        },
        [dataTableFilter]
    )

    const hideRegistro = () => {
        setShowRegistroLibro(false);
    };

    const showRegistro = (data) => {
        dataSelectLibro.current = data;
        setShowRegistroLibro(true);
    };

    const dataTableHeader = (
        <div className="p-shadow-1 p-p-3">
            <div className="p-formgrid p-grid p-col-12 p-fluid p-p-0">
                <div className="p-col-12 p-md-6 p-lg-2 p-mt-4">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} className="p-mr-3" placeholder="Buscar..." />
                    </span>
                </div>

                <div className="p-col-12 p-md-6 p-lg-3">
                    <FiltroNivelCurso getFiltroNivelCurso={getFiltroNivelCurso} reset={filtroRef} />
                </div>

                <div className="p-col-8 p-md-2 p-lg-3 p-offset-4 p-mt-3" style={{ textAlign: "right" }}>
                    <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadData}></Button>
                </div>
            </div>
        </div>
    );

    return (
        <div className="p-formgrid p-grid p-col-12 card p-fluid p-pt-1">
            <Toast ref={toast} />
            <div style={{ display: showRegistroLibro ? "none" : "block" }} className="p-col-12 p-md-12 p-lg-12">
                {dataTableHeader}
                <div className="p-grid p-col-12">
                    {dataTableFilter?.map((obj, index) => {
                        return (
                            <React.Fragment key={index}>
                                <div className="p-col-12 p-md-3 p-lg-2">
                                    <Libro identifier={index} value={obj} showRegistro={showRegistro} />
                                </div>
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
            <div style={{ display: showRegistroLibro ? "block" : "none" }} className="p-col-12 p-md-12 p-lg-12">
                <PageLibroRegistro value={dataSelectLibro.current} hideRegistro={hideRegistro} />
            </div>
        </div>
    );
};
